import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaShieldAlt, FaLock } from "react-icons/fa";
import "./addcoin.css";

const AddCoins = () => {
  const navigate = useNavigate();

  const paymentMethods = [
    {
      id: 1,
      name: "EasyPaisa",
      logo: "./images/Easypaisa-logo.png",
      route: "/easypaisa",
      description: "Instant deposits via mobile wallet"
    },
    {
      id: 2,
      name: "JazzCash",
      logo: "/images/new-Jazzcash-logo.png",
      route: "/jazzcash",
      description: "Secure mobile payments"
    },
    {
      id: 3,
      name: "Credit Card",
      logo: "./images/Credit-Card-System-Recovery-Logo-Graphics-54092534-1-580x387-removebg-preview.png",
      route: "/creditcard",
      description: "Visa/Mastercard payments",
      comingSoon: true
    },
    {
      id: 4,
      name: "Bank Transfer",
      logo: "./images/download-removebg-preview.png",
      route: "/banktransfer",
      description: "Direct bank deposits",
      comingSoon: true
    }
  ];

  return (
    <div className="gb-payment-container">
      <div className="gb-payment-header">
      <button className="gb-back-button" onClick={() => navigate(-1)}>
          <FaChevronLeft className="icon" /> BACK TO WALLET
        </button>
        
        <h1 className="gb-payment-title">ADD COINS</h1>
        <div className="gb-security-banner">
          <FaLock className="security-icon" />
          <span>SECURE PAYMENT GATEWAY</span>
        </div>
      </div>

      <div className="gb-payment-content">
        <div className="gb-payment-intro">
          <h2>Select Payment Method</h2>
          <p className="gb-payment-subtext">
            <FaShieldAlt className="icon" /> All transactions are encrypted with 256-bit SSL security
          </p>
        </div>

        <div className="gb-payment-grid">
          {paymentMethods.map((method) => (
            <Link 
              to={method.comingSoon ? "#" : method.route} 
              className={`gb-payment-card ${method.comingSoon ? "coming-soon" : ""}`}
              key={method.id}
            >
              {method.comingSoon && (
                <div className="gb-coming-soon">COMING SOON</div>
              )}
              <div className="gb-payment-logo-container">
                <img 
                  src={method.logo} 
                  alt={method.name} 
                  className="gb-payment-logo" 
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "./images/payment-default.png";
                  }}
                />
              </div>
              <h3>{method.name}</h3>
              <p>{method.description}</p>
              {!method.comingSoon && (
                <div className="gb-select-button">SELECT</div>
              )}
            </Link>
          ))}
        </div>

        <div className="gb-payment-security">
          <div className="gb-security-feature">
            <div className="gb-security-icon">
              <FaLock />
            </div>
            <div>
              <h4>Secure Transactions</h4>
              <p>Bank-level encryption for all payments</p>
            </div>
          </div>
          <div className="gb-security-feature">
            <div className="gb-security-icon">
              <FaShieldAlt />
            </div>
            <div>
              <h4>Instant Processing</h4>
              <p>Coins added to your account immediately</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCoins;